import { render, staticRenderFns } from "./DhmeProjectAssemblyPlanningAutomated.vue?vue&type=template&id=6bc525f0&scoped=true"
import script from "./DhmeProjectAssemblyPlanningAutomated.vue?vue&type=script&lang=js"
export * from "./DhmeProjectAssemblyPlanningAutomated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc525f0",
  null
  
)

export default component.exports